import { Lager_Treyd_Users } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

export type UserCompany = {
  id: number;
  name: string;
  is_active: boolean;
};
export type UserRecordInCompany = Pick<
  Lager_Treyd_Users,
  'company_user_id' | 'invitation_accepted_at'
> & {
  company: UserCompany;
};

export type GetUserRecordsInCompaniesQueryType = {
  lager_treyd_users: UserRecordInCompany[];
};

export type GetUserRecordsInCompaniesVariablesType = {
  userId: number;
};
export const getUserRecordsInCompaniesQuery = gql`
  query getUserRecordsInCompanies($userId: Int!) {
    lager_treyd_users(where: { user_id: { _eq: $userId } }) {
      company_user_id
      invitation_accepted_at
      company {
        id
        name
        is_active
      }
    }
  }
` as TypedDocumentNode<
  GetUserRecordsInCompaniesQueryType,
  GetUserRecordsInCompaniesVariablesType
>;
